<section class="feature-section section-gap soft-blue-bg">
    <div class="container">
        <div class="row justify-content-center align-items-center">
            <div class="col-lg-6 col-md-10">
                <div class="tile-gallery-one wow fadeInLeft" data-wow-delay="0.3s">
                    <div class="img-one">
                        <img src="assets/img/tile-gallery/tile-gallery-01.jpg" alt="img">
                    </div>
                    <div class="img-two text-right wow fadeInUp" data-wow-delay="0.5s">
                        <img src="assets/img/tile-gallery/tile-gallery-02.jpg" alt="img">
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-10">
                <div class="feature-text-block mt-md-gap-60 wow fadeInRight" data-wow-delay="0.4s">
                    <div class="section-title mb-20">
                        <span class="title-tag">CORE FEATURES</span>
                        <h2 class="title">Get More Good Experience.</h2>
                    </div>
                    <p class="big-text mb-30"> Our knowledge of computers will help us </p>
                    <p>
                        Does any industry face a more complex audience journey and marketing sales process than B2B
                        technology? Consider the number of people who influence a sale, the length of the
                        decision-making cycle, the competing interests of the people who purchase, implement,
                        manage, and use the technology. It’s a lot meaningful content here.
                    </p>
                    <ul class="feature-btn mt-30">
                        <li>
                            <a class="main-btn" routerLink="/about">Learn More</a>
                        </li>
                        <li>
                            <a class="main-btn main-btn-2" routerLink="/about"><i class="fal fa-video"></i> Intro
                                Video</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>